import '../css/Field.css';
import { CollapseableArea } from './CollapseableArea';
import { InfieldDetails } from './InfieldDetails';
import { OutfieldDetails } from './OutfieldDetails';
import PhotoHeader from './PhotoHeader';
import { Reviews } from './Reviews';
import { SurroundingAreaDetails } from './SurroundingAreaDetails';
import StyledRating from '@mui/material/Rating'
import { activePhotos, activeReviews, averageRatingForGroup } from '../utilities/fieldData';

const fieldName = (field) => {
    const nameNumber = field.field_name_number ?? field.group_name ?? 'Field';
    if (parseInt(nameNumber) || nameNumber.length === 1) {
        return `Field ${nameNumber}`
    }
    return nameNumber;
}

export const Field = ({fieldSnapshot}) => {
    const field = fieldSnapshot.data();
    const reviews = activeReviews(field);
    const photos = activePhotos(field).map(p => p.url);
    const avgOverallReview = averageRatingForGroup(reviews, 'overall');

    const reviewCount = () => {
        if (reviews.length === 1) {
            return '1 review'
        }
        return `${reviews.length} reviews`
    }

    return (
        <div className="single-field-detail">
            <h2>{fieldName(field)}</h2>
            <div className="rating-group">
                {avgOverallReview !== undefined &&
                <StyledRating
                    className="rating"
                    name="field-rating"
                    defaultValue={avgOverallReview}
                    precision={0.5}
                    icon={<img alt="Rated" src="/rating-gold.svg" />}
                    emptyIcon={<img alt="Not rated" src="/rating-off.svg" />}
                    readOnly
                />}
                <p>{reviewCount()}</p>
            </div>
            <PhotoHeader photoURLs={photos} />
            <div className="detail-area">
                <CollapseableArea title="Infield" expandedAreaComponent={<InfieldDetails field={field} />} initiallyExpanded />
                <CollapseableArea title="Outfield" expandedAreaComponent={<OutfieldDetails field={field} />} initiallyExpanded />
                <CollapseableArea title="Surrounding Area" expandedAreaComponent={<SurroundingAreaDetails field={field} />} initiallyExpanded />
                <div id={`reviews-${field.id}`}>
                    <CollapseableArea title="Reviews" expandedAreaComponent={<Reviews field={field} />} initiallyExpanded />
                </div>
            </div>
        </div>
    )
}
